module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-gray-9ac9f57f1f6e09ffb3f5e970c944407a.png";